import React from "react";
import { Crown } from "lucide-react";
import { motion } from "framer-motion";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

interface PremiumNudgeProps {
  onDismiss: () => void;
}

export function PremiumNudge({ onDismiss }: PremiumNudgeProps) {
  const navigate = useNavigate();

  return (
    <motion.div
      initial={{ opacity: 0, y: 16, scale: 0.97 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      transition={{ duration: 0.4, ease: "easeOut" }}
    >
    <Card className="p-4 border-orange-warm/30 bg-gradient-to-r from-orange-warm/5 to-primary/5">
      <div className="flex items-start gap-3">
        <div className="bg-orange-warm/10 rounded-full p-2 shrink-0">
          <Crown className="h-5 w-5 text-orange-warm" />
        </div>
        <div className="flex-1 space-y-2">
          <p className="text-sm font-semibold text-foreground">
            Get more from your care search
          </p>
          <p className="text-xs text-muted-foreground">
            Grandpal Premium members get personalised Fair Deal modelling, an enquiry tracker to manage responses from nursing homes, and weekly updates on availability — so you never miss a spot.
          </p>
          <ul className="text-xs text-muted-foreground space-y-1 pt-1">
            <li className="flex items-center gap-1.5">
              <span className="text-primary">✓</span> Unlimited nursing home shortlisting
            </li>
            <li className="flex items-center gap-1.5">
              <span className="text-primary">✓</span> Enquiry tracker with notes
            </li>
            <li className="flex items-center gap-1.5">
              <span className="text-primary">✓</span> Personalised Fair Deal estimates
            </li>
          </ul>
          <div className="flex gap-2 pt-1">
            <Button
              size="sm"
              onClick={() => navigate("/premium")}
              className="h-9 bg-orange-warm hover:bg-orange-warm/90 text-white"
            >
              Explore Premium
            </Button>
            <Button
              size="sm"
              variant="ghost"
              onClick={onDismiss}
              className="h-9 text-muted-foreground"
            >
              Not now
            </Button>
          </div>
        </div>
      </div>
    </Card>
    </motion.div>
  );
}
